import { isStandalone } from '@/mixins/userAgent';

export default {
  bind(el) {
    if (!isStandalone) {
      el.setAttribute('target', '_blank');
      el.setAttribute('rel', 'noopener noreferrer');
    }
  },
};



// WEBPACK FOOTER //
// ./src/directives/outer-link.js